import React, { useState } from 'react';
import iconLeaf from '../../../assets/images/lead-img01.svg';
import iconlinkedin from '../../../assets/images/icon-linkedin2.svg';
import iconSearch from '../../../assets/images/lead-img03.svg';
import CardBox from './CardBox';
import { useNavigate } from 'react-router-dom';
import { InfoSectionStyled } from './InfoSection.styles';
import ConnectAccountModal from './ConnectAccountModal';

const InfoSection = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);

  const handleCardClick = link => {
    sessionStorage.removeItem('step');
    navigate(link);
  };

  const cardsData = [
    {
      icon: iconlinkedin,
      title: 'Connect Account',
      description: 'Connect Email & LinkedIn accounts',
      btn: 'Connect Account',
      btnColor: '#2783EC',
      onClick: () => setOpenModal(true),
    },
    {
      icon: iconLeaf,
      title: 'Find Leads',
      description: 'Create Leads lists',
      btn: 'Find Leads Now',
      onClick: () => navigate('/leads-module'),
      btnColor: '#EC9327',
    },
    {
      icon: iconSearch,
      title: 'Start Email Campaign',
      description: 'Instantly capture and log a new lead.',
      btn: 'Start Campaign',
      onClick: () => handleCardClick('/create-campaign'),
      btnColor: '#0DA06A',
    },
  ];

  return (
    <InfoSectionStyled>
      <div className="card-holder">
        <CardBox arr={cardsData} />
      </div>

      {/* ✅ Custom Modal that mimics ModalContainer style */}
      {openModal && (
        <div className="custom-modal-overlay" onClick={() => setOpenModal(false)}>
          <div className="custom-modal-box" onClick={e => e.stopPropagation()}>
            <button className="custom-modal-close" onClick={() => setOpenModal(false)}>
              ×
            </button>
            <ConnectAccountModal onClose={() => setOpenModal(false)} />
          </div>
        </div>
      )}
    </InfoSectionStyled>
  );
};

export default InfoSection;
